export const CHANNEL_SET = "CHANNEL_SET";
export const CHANNEL_IS = "CHANNEL_IS";
export const CHANNEL_UPDATE = "CHANNEL_UPDATE";
export const CHANNEL_UPDATE_SUCCESS = "CHANNEL_UPDATE_SUCCESS";
export const CHANNEL_RESET = "CHANNEL_RESET";
